import React, { useState, forwardRef, useImperativeHandle } from 'react'
import GridEnumFilter from '../../../components/GridEnumFilter'
import useUpdateEffect from '../../../hooks/useUpdateEffect'
import { tenantStatusEnumList } from '../../../components/AgGrid/enumLists'

const map = {
  STATUS_ACTIVE: ['STATUS_ACTIVE'],
  STATUS_MOVED_OUT: ['STATUS_MOVED_OUT'],
  STATUS_NOT_YET_MOVED_IN: ['STATUS_NOT_YET_MOVED_IN'],
}

export default forwardRef((props, ref) => {
  const { filterChangedCallback } = props

  const [filterModel, setFilterModel] = useState({})

  useUpdateEffect(() => {
    filterChangedCallback()
  }, [filterModel])

  useImperativeHandle(ref, () => {
    return {
      isFilterActive() {
        return filterModel != null && Object.keys(filterModel).length > 0
      },
      getModel() {
        if (filterModel == null || Object.keys(filterModel).length <= 0) {
          return null
        }

        return filterModel
      },
      setModel(model) {
        setFilterModel(model)
      },
    }
  })

  return (
    <GridEnumFilter
      map={map}
      translateLabel={(value, t) => {
        return t(tenantStatusEnumList(value))
      }}
      setFilterModel={setFilterModel}
    />
  )
})
